export default __webpack_public_path__ + "static/media/card2.6cd92565.jpg";